/* eslint-disable */
import React from "react"
import ResponsiveTopBar from "./controllers/ResponsiveTopBar"
import AppMenu from "./controllers/AppMenu"
import { colorSchemeSystem, menuMode } from "../consts/common.const"
import MainLayout from "../components/layouts/MainLayout.layout"
import MainContentLayout from "../components/layouts/MainContentLayout.layout"
import SidebarContext from "../contexts/SidebarContext"
import { ApplicationRoutes } from "./ApplicationRoutes"
import { ScreenDimensionsContextProvider } from "../contexts/ScreenDimensionsContext.context"
import { ReportFiltersContextProvider } from "../contexts/ReportFiltersContext.context"
import { ClientColorsProvider } from "../contexts/data/ClientColors.context"
import useDebugKeybinds from "../hooks/useDebugKeybinds"
import { IndividualReportFiltersContextProvider } from "../contexts/IndividualReportFilters.context"
import { AikaTipsProvider } from "../contexts/TipsProvider.context"
import { useLocation, matchPath } from "react-router-dom"
import { DEFAULT_ROUTES } from "./roleRoutes/defaultRoutes.routes"

export function AuthorizedRoutes() {
  const location = useLocation()
  if (process.env.NODE_ENV !== "production") {
    useDebugKeybinds()
  }

  const matchedRoute = DEFAULT_ROUTES.find((route) =>
    matchPath(route.path, location.pathname)
  )
  const isRouteWithoutMainLayout = Boolean(matchedRoute?.withoutMainLayout)
  const isRouteWithoutContentLayout = Boolean(
    matchedRoute?.withoutContentLayout
  )

  return (
    <ScreenDimensionsContextProvider>
      <ReportFiltersContextProvider>
        <IndividualReportFiltersContextProvider>
          <ClientColorsProvider>
            <AikaTipsProvider>
              {isRouteWithoutMainLayout ?
                isRouteWithoutContentLayout ?
                  <ApplicationRoutes />
                : <MainContentLayout>
                    <ApplicationRoutes />
                  </MainContentLayout>

              : <MainLayout>
                  <ResponsiveTopBar />
                  <AppMenu
                    menuMode={menuMode}
                    colorScheme={colorSchemeSystem}
                  />
                  <MainContentLayout>
                    <ApplicationRoutes />
                  </MainContentLayout>
                </MainLayout>
              }
            </AikaTipsProvider>
          </ClientColorsProvider>
        </IndividualReportFiltersContextProvider>
      </ReportFiltersContextProvider>
    </ScreenDimensionsContextProvider>
  )
}
